import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'
import update from 'immutability-helper'

const initialState = {
  layouts: {},
  overview: {},
  myTasks: {},
  myActive: {},
  overviewAll: {},
  proposalsISentForReview: [],
  proposalsINeedToReview: [],
  proposalsINeedToUpdate: [],
  proposalsReadyToSentToClient: [],
  overviewFetched: false,
  proposalsInReview: []
}

const dashboardReducer = createReducer(initialState, {
  [ACT.LAYOUT_FETCH_SUCCESS](state, action) {
    const { layouts } = action.payload
    return {
      ...state,
      layouts
    }
  },
  [ACT.LAYOUT_SAVE_SUCCESS](state, action) {
    const { layouts } = action.payload
    return {
      ...state,
      layouts
    }
  },
  [ACT.OVERVIEW_FETCH_DONE](state, action) {
    const { overview } = action.payload
    return {
      ...state,
      overview
    }
  },
  [ACT.OVERVIEW_OFFICE_FETCH_SUCCESS](state, action) {
    const { overview } = action.payload
    return {
      ...state,
      overview
    }
  },
  [ACT.OVERVIEW_USER_FETCH_SUCCESS](state, action) {
    const { overview } = action.payload
    return {
      ...state,
      overview
    }
  },
  [ACT.MY_TASKS_FETCH_DONE](state, action) {
    const { myTasks } = action.payload
    return {
      ...state,
      myTasks
    }
  },
  [ACT.MY_ACTIVE_FETCH_DONE](state, action) {
    const { myActive } = action.payload
    return {
      ...state,
      myActive
    }
  },
  [ACT.OVERVIEW_ALL_FETCH_SUCCESS](state, action) {
    const { overviewAll } = action.payload
    return {
      ...state,
      overviewAll
    }
  },
  [ACT.OVERVIEW_ALL_OFFICE_FETCH_SUCCESS](state, action) {
    const { overviewAll } = action.payload
    return {
      ...state,
      overviewAll
    }
  },
  [ACT.OVERVIEW_ALL_USER_FETCH_SUCCESS](state, action) {
    const { overviewAll } = action.payload
    return {
      ...state,
      overviewAll
    }
  },
  [ACT.PROPOSALS_FOR_REVIEW_FETCH_DONE](state, action) {
    const { proposalsISentForReview } = action.payload
    return {
      ...state,
      proposalsISentForReview
    }
  },
  [ACT.PROPOSALS_TO_REVIEW_FETCH_DONE](state, action) {
    const { proposalsINeedToReview } = action.payload
    return {
      ...state,
      proposalsINeedToReview
    }
  },
  [ACT.PROPOSALS_UPDATE_FETCH_DONE](state, action) {
    const { proposalsINeedToUpdate } = action.payload
    return {
      ...state,
      proposalsINeedToUpdate
    }
  },
  [ACT.PROPOSALS_CLIENT_FETCH_DONE](state, action) {
    const { proposalsReadyToSentToClient } = action.payload
    return {
      ...state,
      proposalsReadyToSentToClient
    }
  },
  [ACT.OVERVIEW_WAS_CALLED](state, action) {
    const { overviewFetched } = action.payload
    return {
      ...state,
      overviewFetched
    }
  },
  [ACT.GET_PROPOSALS_IN_REVIEW_FETCH_SUCCESS](state, action) {
    const { proposalsInReview } = action.payload
    return {
      ...state,
      proposalsInReview
    }
  },
  [ACT.DASHBOARD_UPDATE_NEW_DEALS_COUNTER](state) {
    return update(state, {
      myActive: {
        newOpportunityDeals: { $set: state.myActive.newOpportunityDeals + 1 }
      },
      overview: {
        newDeals: { $set: state.overview.newDeals + 1 }
      }
    })
  },
  [ACT.DASHBOARD_UPDATE_NEW_PROPOSALS_COUNTER](state) {
    return update(state, {
      myActive: {
        creationProposals: { $set: state.myActive.creationProposals + 1 }
      }
    })
  }
})

export default dashboardReducer
